import { getSessionId } from "../../authStorage";

export default () => `master:${getSessionId()}`;
